import { useState } from "react";
import { PHONE_NUMBER_DIGITS_REGEX, PHONE_NUMBER_REGEX } from "../../../constants";
import { useAppDispatch } from "../../../redux";
import { setPhone } from "../ContactInfoSlice";

export const usePhoneNumber = (params: { handleClose(): void }) => {
  const { handleClose } = params;
  const dispatch = useAppDispatch();
  const [phone, setPhoneHook] = useState<string | null>("");
  const [dialCode, setDialCode] = useState("");

  const handleAreaCodeChange = (
    _: React.ChangeEvent<{}>,
    value: { name: string; dial_code: string } | null,
    __: any,
    ___?: any
  ) => {
    if (!value) {
      setDialCode("");

      return;
    }

    setDialCode(value.dial_code);
  };

  const validatePhone = (dialCode: string, phoneNumber: string | null) => {
    if (!phoneNumber || dialCode === "" || phoneNumber === "") {
      return false;
    }

    const isValid = PHONE_NUMBER_REGEX.test(phoneNumber);
    return isValid;
  };

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (!PHONE_NUMBER_DIGITS_REGEX.test(value)) return;
    else setPhoneHook(value);

    if (PHONE_NUMBER_REGEX.test(value)) setPhoneHook(value);
    else setPhoneHook(value);
  };

  const updatePhone = () => {
    if (phone === "" && dialCode === "") {
      handleClose();
      return dispatch(setPhone({ dialCode: "", phone: "" }));
    }
    const validation = validatePhone(dialCode, phone);

    if (!validation) return;

    dispatch(setPhone({ dialCode, phone: phone as string }));

    handleClose();
    setPhoneHook("");
    return;
  };

  return {
    updatePhone,
    phone,
    handleAreaCodeChange,
    dialCode,
    handlePhoneChange,
  };
};
